import { useEffect, useState } from 'react';

type ClearFnProp = () => void;
type FnProp = (fn: ClearFnProp) => void;

export default function useInterval(
    f: FnProp,
    delay = 1000,
    autoStart = true,
): { start: FnProp; stop: FnProp; busy: boolean } {
    const [busy, setBusy] = useState<boolean>(autoStart);
    const start = () => setBusy(true); // start
    const stop = () => setBusy(false); // stop

    useEffect(() => {
        // start
        if (!busy) return;
        setBusy(true);
        const t = setInterval(() => f(stop), delay);
        // stop
        return () => {
            setBusy(false);
            clearInterval(t);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [busy, delay]);

    return {
        start,
        stop,
        busy,
    };
}
